import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ResultPage from "./components/ResultPage";
import ArticlePage from "./components/NewsPage";
import PortalPage from "./components/PortalPage";
import { useTracking } from "react-tracking";
import RedirectComponent from "./components/RedirectComponent";
import AISearchResultsPage from "./components/AISearchResultsPage";
import QuizContainerPage from "./components/QuizContainerPage";
import TaskInstructionPage from "./components/TaskInstructionPage";

function App() {
    const configurator = require("core-js/configurator");
    configurator({
        // polyfills will be used only if natives are completely unavailable
        usePolyfill: ["Object.hasOwn"], // polyfills will be used anyway                   // default behavior
    });

    require("core-js/actual");
    const [sequence, setSequence] = React.useState([]);
    const { Track, trackEvent } = useTracking({ page: "NewsPage" });
    return (
        <Track>
            <Router>
                <Routes>
                    <Route path="/:set/:variant/" element={<TaskInstructionPage />} />
                    <Route path="/:set/:variant/:question/" element={<QuizContainerPage />} />
                    <Route path="/ai" element={<AISearchResultsPage />} />
                    <Route path="/result/:id" element={<ResultPage />} />
                    <Route path="/news/:id/:botVariant?" element={<ArticlePage />} />
                    <Route path="/go/:id/:botVariant/:portalVariant" element={<RedirectComponent />} />
                    <Route
                        path="/portal/:id/:botVariant?"
                        element={<PortalPage sequence={sequence} setSequence={setSequence} />}
                    />
                </Routes>
            </Router>
        </Track>
    );
}

export default App;
